module.exports = __webpack_public_path__ + "static/media/vc.c4b37613.svg";